import React, { } from 'react';
import { Grid } from '@material-ui/core';
import { Elements, PaymentElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { stripeCustomFont, stripeFormAppearance, stripeFormOptions, stripePromise } from '../../../utils/stripe';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { StripePendingSubscription } from '../../../gql/subscriptions';
import { TextBlock } from 'neon-design-system';

interface StripePaymentFormProps {
	onElementsReady: (stripe: Stripe | null, elements: StripeElements | null) => void;
	stripeSubscriptionData: StripePendingSubscription;
}

export const StripePaymentForm = ({ onElementsReady, stripeSubscriptionData }: StripePaymentFormProps) => {
	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Elements
					stripe={stripePromise}
					options={{
						clientSecret: stripeSubscriptionData.createStripeSubscription.clientSecret,
						fonts: stripeCustomFont,
						appearance: stripeFormAppearance
					}}>
					<ElementsConsumer>
						{({ stripe, elements }) => (
							<PaymentElement
								options={stripeFormOptions}
								onReady={() => onElementsReady(stripe, elements)} />
						)}
					</ElementsConsumer>
				</Elements>
			</Grid>
			<Grid item xs={12}>
				<TextBlock styleName="caption1" color="grey" shade={400}>
					Payment services provided by Stripe
				</TextBlock>
			</Grid>
		</Grid>
	);
};
